export const MainColor: string = "#0d9488";
